export default __webpack_public_path__ + "static/media/logo-en.77d0faa1.png";